import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl text-center">
          <h1 className="text-6xl md:text-8xl font-bold tracking-tight text-foreground mb-4">404</h1>
          <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground mb-6">
            Page introuvable
          </h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-10 max-w-xl mx-auto">
            La page que vous recherchez n'existe pas ou a &eacute;t&eacute; d&eacute;plac&eacute;e.
            D&eacute;couvrez nos solutions d'automatisation IA pour votre entreprise.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Link
              to="/"
              className="inline-flex items-center rounded-full px-8 h-11 text-base font-semibold bg-[hsl(211,100%,50%)] hover:bg-[hsl(211,100%,45%)] text-white btn-premium no-color-transition"
            >
              Retour &agrave; l'accueil
            </Link>
            <Link
              to="/#audit"
              className="inline-flex items-center rounded-full px-8 h-11 text-base font-medium border border-border/60 hover:bg-secondary/80 transition-colors"
            >
              Audit Gratuit
            </Link>
          </div>

          <nav aria-label="Pages populaires" className="text-left max-w-md mx-auto">
            <h3 className="text-sm font-semibold tracking-wide uppercase text-foreground mb-4">
              Pages populaires
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/services/restaurant" className="text-muted-foreground hover:text-foreground transition-colors">
                  Automatisation IA pour restaurants
                </Link>
              </li>
              <li>
                <Link to="/services/medical" className="text-muted-foreground hover:text-foreground transition-colors">
                  Automatisation IA pour cabinets m&eacute;dicaux
                </Link>
              </li>
              <li>
                <Link to="/services/retail" className="text-muted-foreground hover:text-foreground transition-colors">
                  Automatisation IA pour commerces
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </main>
      <Footer />
    </div>
  );
}
